/**
 * IMPORTS
 */

import { recepcaoRepository } from "@/repositories/recepcao";

/**
 * Função que busca dados dos pedidos finalizados 🛠️.
 */
const handleGetRemessasEmRecepcao = async (
  accessToken: string,
  currentPage: number,
  itemsPerPage: number,
  searchItem: string
) => {
  try {
    const data = await recepcaoRepository.buscarRemessaEmRecepcao(
      accessToken,
      currentPage,
      itemsPerPage,
      searchItem
    );

    return data;
  } catch (error: any) {
    return error;
  }
};

/**
 * EXPORTS
 */
export { handleGetRemessasEmRecepcao };
